import { create } from "zustand"
import { devtools } from "zustand/middleware"

export type Memory = {
  name: string
  message: string
  color: string
}

export interface GuestbookState {
  isAddMemoryOpen: boolean
  setIsAddMemoryOpen: (isAddMemoryOpen: boolean) => void
}

export const useGuestbookStore = create<GuestbookState>()(
  devtools((set) => ({
    isAddMemoryOpen: false,
    setIsAddMemoryOpen: (isAddMemoryOpen: boolean) => set({ isAddMemoryOpen }),
  })),
)
